import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-loading-ring';
export var ID = 'icon-loading-ring';
/* eslint-disable max-len */

export var SVGLoadingRing = function SVGLoadingRing() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "uil-ring-alt"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "100",
    height: "100",
    fill: "none",
    className: "bk"
  }), React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "40",
    stroke: "#ffddb1",
    fill: "none",
    strokeWidth: "10",
    strokeLinecap: "round"
  }), React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "40",
    stroke: "#faa635",
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round"
  }, React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "2s",
    repeatCount: "indefinite",
    from: "0",
    to: "502"
  }), React.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "2s",
    repeatCount: "indefinite",
    values: "150.6 100.4;1 250;150.6 100.4"
  })));
};
/* eslint-disable max-len */

var LoadingRing = function LoadingRing(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLoadingRing
  });
};

LoadingRing.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default LoadingRing;